<template>
  <div class="services-grid">
    <div class="card" v-for="(service, index) in services" :key="index">
      <!-- 图标和序号部分 -->
      <div class="card-header">
        <div class="icon-box">
          <!-- 模拟六边形图标 -->
          <div class="hex-icon"></div>
        </div>
        <span class="card-num">{{ service.num }}</span>
      </div>

      <!-- 文本内容 -->
      <h3 class="card-title">{{ service.title }}</h3>
      <p class="card-desc">{{ service.desc }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      services: [
        { num: '01', title: 'Scam & Phishing Recovery', desc: 'Investigation and recovery support for funds lost to fraudulent platforms, fake investments, or phishing attacks.' },
        { num: '02', title: 'Wallet Access Recovery', desc: 'Assistance restoring access to wallets with lost seed phrases, forgotten passwords, or corrupted files.' },
        { num: '03', title: 'Blockchain Transaction Tracing', desc: 'On-chain analysis and fund tracking to map where your cryptocurrency moved and support recovery efforts.' },
        { num: '04', title: 'Exchange Account Recovery', desc: 'Support navigating exchange account recovery, verification disputes, and frozen account resolution.' },
        { num: '05', title: 'Smart Contract Exploit Recovery', desc: 'Assessment and recovery guidance for losses from malicious contracts, rug pulls, and token vulnerabilities.' },
        { num: '06', title: 'Ransom & Extortion Tracing', desc: 'Documentation and tracing support for funds paid under coercion, extortion threats, or ransomware attacks.' },
        { num: '07', title: 'Fraud Documentation & Reporting', desc: 'Preparation of comprehensive case files and evidence packages for law enforcement and regulatory reporting.' },
        { num: '08', title: 'Ongoing Case Monitoring', desc: 'Continuous tracking of recovery case status and on-chain movement throughout the investigation process.' }
      ]
    };
  }
}
</script>

<style scoped>
/* 网格布局：大屏4列，中屏2列，小屏1列 */
.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 25px;
  padding: 0 5% 80px;
}

/* 核心卡片样式：深色背景 + 特殊折角边框 */
.card {
  position: relative;
  background: #0a121f;
  /* 卡片深色背景 */
  border-radius: 6px;
  padding: 30px 25px;
  transition: all 0.3s ease;
  overflow: hidden;
  /* 防止背景粒子溢出 */
}

/* 模拟四角的括号状折线 (使用伪元素实现L型边框) */
.card::before,
.card::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #2a3a52;
  transition: all 0.3s ease;
  z-index: 1;
}

.card::before {
  top: 12px;
  left: 12px;
  border-right: none;
  border-bottom: none;
}

.card::after {
  bottom: 12px;
  right: 12px;
  border-left: none;
  border-top: none;
}

/* 悬停效果：边框变亮，上浮 */
.card:hover {
  transform: translateY(-5px);
  background: #0e1a2a;
}

.card:hover::before,
.card:hover::after {
  border-color: #00d4ff;
  /* 悬停时边框变蓝 */
}

/* 头部排版 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 25px;
}

/* 六边形图标模拟 */
.icon-box {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hex-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #2a3a52, #15202e);
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  border: 1px solid #3a4a62;
}

.card-num {
  color: #5a6b85;
  font-weight: bold;
  font-size: 1.1rem;
}

.card-title {
  color: #fff;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 15px;
  line-height: 1.4;
}

.card-desc {
  color: #8a9bb5;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
}

/* 响应式断点 */
@media (max-width: 1200px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
    padding: 0 20px 60px;
  }
}
</style>